import Styled from 'styled-components'

export const Content = Styled.div`
`
export const Footer = Styled.div`
  position: absolute;
  bottom: 0;
  margin-bottom: 24px;
  width: 100%;
  display: flex;
  justify-content: center;
`

export const Img = Styled.img`
  width: 139.07px;
  height: 104.28px;
  margin-bottom: 10px;
`

export const OrderNumber = Styled.span`
  position: relative;
  left: 30%
`

export const SubLabel = Styled.p`
  color: #767F8D;
  font-weight: 400;
  font-size: 15px;
  line-height: 145%;
  text-align: center;
`

export const Label = Styled.h3`

`